import { h } from "omi";

import { IconProps } from "@/wc/components";

export function ThumbsUpIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 21" width={width} height={height}>
      <path
        d="M5.833 18.954V9.787m-4.166 1.667v5.833c0 .92.746 1.667 1.666 1.667h11.189a2.5 2.5 0 0 0 2.47-2.12l.898-5.833a2.5 2.5 0 0 0-2.47-2.88H12.5a.833.833 0 0 1-.833-.834V4.342c0-1.135-.92-2.055-2.055-2.055-.27 0-.516.16-.626.407L6.053 9.292a.833.833 0 0 1-.761.495H3.333c-.92 0-1.666.746-1.666 1.667Z"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
